var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgImportantAlert = function SvgImportantAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M15 23a8 8 0 110-16 8 8 0 010 16zm-.779-7.372l-1.06-1.06a.5.5 0 00-.707 0l-.708.707a.5.5 0 000 .707l2.122 2.121a.5.5 0 00.707 0l4.243-4.242a.5.5 0 000-.707l-.708-.708a.5.5 0 00-.707 0l-3.182 3.182z"
  })));
};
export default SvgImportantAlert;